const fetch = require('node-fetch')

const _makeRequest = async({ method, url, headers, body }) => {
    return await fetch(url, {
        method,
        headers: Object.assign({
            'Cache-Control': 'max-age=1, stale-while-revalidate=59',
        }, headers),
        body
    });
}

const GET = async(url) => {
    return await _makeRequest({
        method: 'GET',
        url
    });
}

const POST = async(url, body) => {
    return await _makeRequest({
        method: 'POST',
        url,
        body,
        headers: {
            "Content-Type":"application/json"
        }
    });
}

module.exports = { GET, POST }